import { secureExternalLinks } from '@/utils/dom';

export const initLoader = () => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.remove('is-not-loaded');

  window.addEventListener('load', () => {
    document.documentElement.classList.add('is-loaded');

    if (!sessionStorage.getItem('first-visit')) {
      document.documentElement.classList.add('is-first-loaded');
      sessionStorage.setItem('first-visit', 'true');
    }

    setTimeout(() => {
      document.documentElement.classList.add('is-ready');
    }, 600);

    // 🔐 Apply rel="noopener noreferrer" for all target="_blank" links
    secureExternalLinks();
  });
};
